import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltip", "truncateStringProps", "as"];
import { Component } from 'react';
import { Media } from '../Media';
import { MediaBody } from '../MediaBody';
import { MediaRight } from '../MediaRight';
import { TruncateString } from '../TruncateString';
import { TableHoverContent } from './TableHoverContent';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { View } from '../View';
import { filterProps } from '../../../utils/filterProps';
import { POPOVER_TRANSITION_TIMING } from '../../../constants/times';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const POPOVER_TRANSITION_DELAY = parseInt(POPOVER_TRANSITION_TIMING, 10);
export class TableHoverCell extends Component {
  constructor(props) {
    super(props);
    this.handleHoverContentOpenChange = evt => {
      const rowIsHovered = evt.target.value;
      if (!rowIsHovered !== this.state.hoverContentIsClosing) {
        // Remove hover content's left margin while closing (#2412)
        this.setState({
          hoverContentIsClosing: !rowIsHovered
        });
      }
      this.setState({
        rowIsHovered
      });
      if (rowIsHovered) {
        clearTimeout(this._hideTimeout);
        this.setState({
          hoverContentIsClosed: false
        });
      } else {
        this._hideTimeout = setTimeout(() => {
          this.setState({
            hoverContentIsClosed: true
          });
        }, POPOVER_TRANSITION_DELAY);
      }
    };
    this.handleTooltipOpenChange = evt => {
      this.setState({
        tooltipIsOpen: !!evt.target.value
      });
    };
    this.renderHoverContent = () => {
      const {
        hoverContent,
        hoverContentProps
      } = this.props;
      const {
        hoverContentIsClosing,
        hoverContentIsClosed,
        rowIsHovered,
        tooltipIsOpen
      } = this.state;
      const open = hoverContentProps && hoverContentProps.open || rowIsHovered || tooltipIsOpen;
      if (!hoverContent) {
        return null;
      }
      const MediaRightContent = /*#__PURE__*/_jsx(MediaRight, {
        marginInlineStart: hoverContentIsClosing && !open ? '0 !important' : undefined,
        minInlineSize: "auto",
        children: /*#__PURE__*/_jsx(TableHoverContent, Object.assign({
          open: open,
          onOpenChange: this.handleHoverContentOpenChange,
          shrinkOnHide: true
        }, hoverContentProps, {
          children: hoverContentIsClosed && !open ? /*#__PURE__*/_jsx(ScreenReaderOnly, {
            children: hoverContent
          }) : hoverContent
        }))
      });
      return MediaRightContent;
    };
    const {
      hoverContentProps: _hoverContentProps
    } = props;
    const _rowIsHovered = _hoverContentProps ? !!_hoverContentProps.open : false;
    this.state = {
      rowIsHovered: _rowIsHovered,
      hoverContentIsClosed: !_rowIsHovered,
      hoverContentIsClosing: false,
      tooltipIsOpen: false
    };
  }
  componentWillUnmount() {
    clearTimeout(this._hideTimeout);
  }
  render() {
    const _this = this,
      {
        props: {
          children,
          tooltip = true,
          truncateStringProps,
          as: OuterElement = 'td'
        },
        state: {
          rowIsHovered,
          tooltipIsOpen
        }
      } = _this,
      rest = _objectWithoutPropertiesLoose(_this.props, _excluded);
    const {
      tokenProps,
      domProps
    } = filterProps(rest);
    return /*#__PURE__*/_jsx(View, Object.assign({
      as: OuterElement
    }, domProps, tokenProps, {
      children: /*#__PURE__*/_jsxs(Media, {
        align: "center",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(MediaBody, {
          children: /*#__PURE__*/_jsx(TruncateString, Object.assign({
            open: tooltipIsOpen
          }, truncateStringProps, {
            "data-content-hovered": rowIsHovered,
            tooltip: tooltip,
            onOpenChange: this.handleTooltipOpenChange,
            children: children
          }))
        }), this.renderHoverContent()]
      })
    }));
  }
}